//export const SERVER_URL = "http://localhost:3001/"
export const SERVER_URL = "/"
//export const HOST="http://localhost:3001/"
export const HOST="http://95.213.194.246:3001/"